<template>
    <!-- 用户头像 -->
    <img v-if="userInfo.avatar"
        :src="userInfo.avatar"
        :alt="userInfo.nickname"
        @click="toUserInfo">
</template>

<script>
import {mapState} from 'vuex';

export default {
    props: {
        userInfo: Object
    },
    computed: {
        ...mapState({
            webPages: state => state.common.webPages
        })
    },
    methods: {
        // 跳转至用户中心页
        toUserInfo() {
            const userNo = this.userInfo.userNo;
            window.open(`${this.webPages.userInfo}/${userNo}`);
        }
    }
};
</script>
